import { EnrichmentMode } from './storefrontParams.js';
export var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["ACTIVE"] = "ACTIVE";
    InvitationStatus["PENDING"] = "PENDING";
    InvitationStatus["EXPIRED"] = "EXPIRED";
})(InvitationStatus || (InvitationStatus = {}));
export var OnboardingStep;
(function (OnboardingStep) {
    OnboardingStep["ACTIVATE_TRIAL"] = "activate-trial";
    OnboardingStep["BOOK_CALL"] = "book-call";
    OnboardingStep["CHECKOUT_COMPLETED"] = "checkout-completed";
    OnboardingStep["META_APP_INSTALL"] = "meta-app-install";
    OnboardingStep["META_APP_INSTALLED"] = "meta-app-installed";
    OnboardingStep["META_SETUP"] = "meta-setup";
    OnboardingStep["RESTART_SUBSCRIPTION"] = "restart-subscription";
    OnboardingStep["SHOPIFY_APP_INSTALL"] = "shopify-app-install";
})(OnboardingStep || (OnboardingStep = {}));
export var BlackCrowPageIds;
(function (BlackCrowPageIds) {
    BlackCrowPageIds["landingPage"] = "bcai.storefront.landing_page";
    BlackCrowPageIds["cartPage"] = "bcai.storefront.cart";
    BlackCrowPageIds["addToCartPage"] = "bcai.storefront.add_to_cart";
    BlackCrowPageIds["pdpPage"] = "bcai.storefront.pdp";
    BlackCrowPageIds["plpPage"] = "bcai.storefront.plp";
    BlackCrowPageIds["initiateCheckoutPage"] = "bcai.storefront.initiate_checkout";
})(BlackCrowPageIds || (BlackCrowPageIds = {}));
export const CARD_VP_DISPLAY_FIELDS = [
    'carouselImages',
    'bodyBadges',
    'title',
    'reviews',
];
export const CARD_VP_DISPLAY_OMIT_KEYS = [
    'bodyContent',
    'reviewAnalysis',
    'productOptionGuide',
    'carouselImagePerceptualHashes',
];
export var ApiSectionType;
(function (ApiSectionType) {
    ApiSectionType["ACCORDION"] = "ACCORDION";
    ApiSectionType["HTML"] = "HTML";
    ApiSectionType["CAROUSEL"] = "CAROUSEL";
    ApiSectionType["VIDEO_CAROUSEL"] = "VIDEO_CAROUSEL";
    ApiSectionType["PLP"] = "PLP";
    ApiSectionType["PERSONALIZED_PLP"] = "PERSONALIZED_PLP";
    ApiSectionType["PRODUCT_CARD"] = "PRODUCT_CARD";
    ApiSectionType["REVIEWS_SUMMARY"] = "REVIEWS_SUMMARY";
    ApiSectionType["REVIEWS_SECTION"] = "REVIEWS_SECTION";
    ApiSectionType["HEADER_TEXT"] = "HEADER_TEXT";
    ApiSectionType["BODY_TEXT"] = "BODY_TEXT";
    ApiSectionType["UPSELL_BOX"] = "UPSELL_BOX";
    ApiSectionType["RICH_TEXT"] = "RICH_TEXT";
    ApiSectionType["INLINE_PDP"] = "INLINE_PDP";
    ApiSectionType["CTA_BUTTON"] = "CTA_BUTTON";
    ApiSectionType["AI_REVIEWS_SUMMARY"] = "AI_REVIEWS_SUMMARY";
    ApiSectionType["REVIEWS_CAROUSEL"] = "REVIEWS_CAROUSEL";
    ApiSectionType["REVIEWS_IMAGES"] = "REVIEWS_IMAGES";
    ApiSectionType["COLLECTIONS_SECTION"] = "COLLECTIONS_SECTION";
    ApiSectionType["SPACER"] = "SPACER";
})(ApiSectionType || (ApiSectionType = {}));
export const SPACER_SPACING_PX_VALUES = [
    6, 12, 18, 24, 30, 36, 42, 48, 54, 60,
];
export const DEFAULT_SPACER_SPACING_PX = 12;
/**
 * An inline PDP shows the purchase module alone unless something deliberately
 * asks for the product's body content or its reviews: inlined mid-page either
 * one buries every section under it.
 */
export const DEFAULT_INCLUDE_PDP_CONTENT = false;
export const DEFAULT_INCLUDE_PDP_REVIEWS = false;
export const HIGHLIGHTED_PRODUCT_HASH = 'HIGHLIGHTED_PRODUCT_HASH';
export var ApiProductSource;
(function (ApiProductSource) {
    ApiProductSource["RECENTLY_VIEWED"] = "RECENTLY_VIEWED";
    ApiProductSource["ADDED_TO_CART"] = "ADDED_TO_CART";
    ApiProductSource["PURCHASED"] = "PURCHASED";
})(ApiProductSource || (ApiProductSource = {}));
export var ApiProductGridLayout;
(function (ApiProductGridLayout) {
    ApiProductGridLayout["GRID"] = "GRID";
    ApiProductGridLayout["HORIZONTAL_SCROLL"] = "HORIZONTAL_SCROLL";
})(ApiProductGridLayout || (ApiProductGridLayout = {}));
export const MIN_PRODUCT_GRID_COUNT = 1;
export const MAX_PRODUCT_GRID_COUNT = 500;
export const DEFAULT_PRODUCT_GRID_COUNT = 8;
/**
 * Tag used to exclude products from all dynamic product grids
 * (Best Sellers, Recently Viewed, Personalized Product Grids).
 * Products with this tag in Shopify will not appear in these grids.
 */
export const DYNAMIC_GRID_EXCLUSION_TAG = 'black_crow_do_not_show_in_dynamic_grids';
export var ApiProductGridType;
(function (ApiProductGridType) {
    ApiProductGridType["BEST_SELLERS"] = "BEST_SELLERS";
    ApiProductGridType["OFTEN_BOUGHT_TOGETHER"] = "OFTEN_BOUGHT_TOGETHER";
    ApiProductGridType["RECENTLY_VIEWED"] = "RECENTLY_VIEWED";
    ApiProductGridType["SHOP_THE_COLLECTION"] = "SHOP_THE_COLLECTION";
})(ApiProductGridType || (ApiProductGridType = {}));
export const IMAGE_SLOT_KIND_VALUES = [
    'PRODUCT_HERO',
    'LIFESTYLE',
    'TEXTURE_SWATCH',
    'INGREDIENT_CALLOUT',
    'BEFORE_AFTER',
    'APPLICATION',
    'FEATURE_GRAPHIC',
];
export var LP_BUTTON_TYPE;
(function (LP_BUTTON_TYPE) {
    LP_BUTTON_TYPE["LINK"] = "LINK";
    LP_BUTTON_TYPE["PDP"] = "PDP";
    LP_BUTTON_TYPE["PLP"] = "PLP";
    LP_BUTTON_TYPE["NONE"] = "NONE";
    LP_BUTTON_TYPE["BUY_NOW"] = "BUY_NOW";
    LP_BUTTON_TYPE["ADD_TO_CART"] = "ADD_TO_CART";
    LP_BUTTON_TYPE["ADD_TO_CART_AND_BUY_NOW"] = "ADD_TO_CART_AND_BUY_NOW";
})(LP_BUTTON_TYPE || (LP_BUTTON_TYPE = {}));
export var INLINE_CTA_ACTION;
(function (INLINE_CTA_ACTION) {
    INLINE_CTA_ACTION["ADD_TO_CART"] = "ADD_TO_CART";
    INLINE_CTA_ACTION["BUY_NOW"] = "BUY_NOW";
})(INLINE_CTA_ACTION || (INLINE_CTA_ACTION = {}));
export const DEFAULT_BUTTON_TEXT_BY_TYPE = {
    [LP_BUTTON_TYPE.BUY_NOW]: 'Buy Now',
    [LP_BUTTON_TYPE.ADD_TO_CART]: 'Add to Cart',
    [LP_BUTTON_TYPE.ADD_TO_CART_AND_BUY_NOW]: 'Add to Cart|Buy Now',
    [LP_BUTTON_TYPE.PDP]: 'View Product',
    [LP_BUTTON_TYPE.PLP]: 'Shop Products',
    [LP_BUTTON_TYPE.LINK]: 'Shop Products',
};
export const isProductTargetedButtonType = (type) => type === LP_BUTTON_TYPE.PDP ||
    type === LP_BUTTON_TYPE.BUY_NOW ||
    type === LP_BUTTON_TYPE.ADD_TO_CART ||
    type === LP_BUTTON_TYPE.ADD_TO_CART_AND_BUY_NOW;
export const isCartActionButtonType = (type) => type === LP_BUTTON_TYPE.BUY_NOW ||
    type === LP_BUTTON_TYPE.ADD_TO_CART ||
    type === LP_BUTTON_TYPE.ADD_TO_CART_AND_BUY_NOW;
export const isCartActionButton = (button) => !!button && isCartActionButtonType(button.type);
export const isProductTargetedButton = (button) => !!button && isProductTargetedButtonType(button.type);
export * from './api-types/brandBenefits.js';
export * from './api-types/brandGuidelines.js';
export * from './api-types/promotions.js';
export * from './api-types/scheduledPromotion.js';
export * from './api-types/customization.js';
export * from './api-types/landingPageBannerBenefit.js';
export * from './api-types/reviewsCarousel.js';
export * from './api-types/virtualProduct.js';
export * from './api-types/sellingPlans.js';
export * from './api-types/brandChat.js';
export * from './api-types/supportTickets.js';
